












// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartExportationContainer from '@/components/charts/ChartExportationContainer.vue';
import ChartRunningSpeedCadence from '@/components/charts/running/ChartRunningSpeedCadence.vue';
// Import utils ------------------------------------------------------------------------------------
import { useUnit } from '@/utils/unit.utils';
// Import helpers ----------------------------------------------------------------------------------
import { getUnit, EValueTypeUnit } from '@/helpers/helped-chart-functions.helper';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ExportationFrameRunningChartSpeedCadence',
  components: {
    ChartExportationContainer,
    ChartRunningSpeedCadence
  },
  props: {
    segments: {
      type: Object,
      required: true
    },
    analysisDate: {
      type: String,
      required: false
    },
    hideTitle: {
      type: Boolean
    },
    displayTooltips: {
      type: Boolean
    }
  },
  setup(properties) {
    const { isImperial } = useUnit().currentUnit();
    const { currentUnit } = useUnit();
    const speedUnit = computed(() => getUnit(EValueTypeUnit.Speed));

    const valid = computed(
      () =>
        !!properties.segments.running_step_cadence?.global?.avg &&
        !!properties.segments.running_speed?.global?.avg
    );

    return {
      valid,
      speedUnit,
      currentUnit,
      isImperial
    };
  }
});
